module.exports = "../dist/img/product-detail-4-23.0883.jpg";